import React from 'react'
import styles from './Buttons.module.css'
import ButtonAction from '../Includes/ButtonAction'
import {
  Stack
} from '@mui/material'
import {
  get_password
} from '../../Functions/Functions'

const Buttons = ({
  state,
  password,
  setPassword
}) => {
  const [error, setError] = React.useState(false)
  const [copied, isCopied] = React.useState(false)
  const Copy = () => {
    navigator.clipboard.writeText(password)
      .then(() => {
        isCopied(true)
        setTimeout(() => {
          isCopied(false)
        }, 1500)
      })
      .catch(() => {
        setError(true)
        setTimeout(() => {
          setError(false)
        }, 1500)
      })
  }
  return (
    <Stack
      spacing={2}
      direction="row"
      className={styles.buttons}
    >
      <ButtonAction
        onClick={() => setPassword(get_password(state))}
      >
        Nouveau
      </ButtonAction>
      {
        (copied)
          ? <ButtonAction color="success">Copié</ButtonAction>
          : (error)
            ? <ButtonAction color="error">Erreur</ButtonAction>
            : <ButtonAction
                onClick={() => Copy(password)}
              >
                Copier
              </ButtonAction>
      }
    </Stack>
  )
}

export default Buttons
